var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTiktok = function SvgTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.37.76 11.904 0H9.088v6.852l-.01 6.694c.005.05.01.104.01.154 0 1.675-1.315 3.043-2.936 3.043-1.622 0-2.936-1.363-2.936-3.043 0-1.676 1.314-3.044 2.936-3.044.336 0 .662.065.964.174V7.49a5.57 5.57 0 0 0-.964-.085c-3.344.005-6.069 2.83-6.069 6.3C.083 17.176 2.808 20 6.157 20c3.348 0 6.073-2.825 6.073-6.295V5.743c1.214 1.258 2.783 2.487 4.52 2.88V5.206c-1.886-.865-3.762-3.42-4.38-4.445Z",
    fill: "currentColor"
  })));
};
export default SvgTiktok;